import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { userQuery } from '../../../core/authentication/queries';
import { useAppSelector } from '../../../types';
import { EmptyReference, TextInformation, Title } from './styles';

// Component used only if referenceList is empty but will be implemented later
export const EmptyReferenceList: FC = () => {
    const { t } = useTranslation();
    const user = useAppSelector(userQuery);

    return (
        <EmptyReference>
            <TextInformation>
                {t('reference.welcomeMessage')} {user?.lastName} {user?.firstName} !
            </TextInformation>
            <Title>{t('reference.emptyReference')}</Title>
        </EmptyReference>
    );
};
